import React from "react";
import { CheckCircle } from "lucide-react";

const ProjectOverview = () => {
  return (
    <section
      id="project"
      className="pt-20 pb-10 bg-gradient-to-br from-gray-50 to-emerald-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 mt-10 items-center">
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-gray-900">
              Welcome to Floret Town
            </h2>
            <p className="text-md text-gray-700 leading-relaxed">
              A one-of-a-kind residential township where every detail is
              inspired by the charm of flowers, the essence of fragrance, and
              the tranquility of greenery. Thoughtfully conceptualized and
              crafted by V-Trims Design, Floret Town is not just a place to live
              — it's an immersive experience of nature and elegance.
            </p>
            <p className="text-md text-gray-700 leading-relaxed">
              Each corner of the township is graced with vibrant blooms and lush
              green landscapes, offering a refreshing, picturesque environment
              that soothes the senses and nurtures the soul. The delicate
              fragrance of flowers fills the air, creating a pleasant and
              inviting atmosphere.
            </p>
            <p className="text-md text-gray-700 leading-relaxed">
              Located on Lucknow Outer Ring Road, Floret Town is an ideal haven
              for nature lovers, wellness seekers, and anyone who dreams of
              living in harmony with nature — all while being seamlessly
              connected to the heart of the city.
            </p>
            <div className="flex items-center space-x-4 pt-4">
              <div className="flex items-center space-x-2 text-emerald-600">
                <CheckCircle size={20} />
                <span className="font-medium">
                  Masterplanned by FB Group
                </span>
              </div>
            </div>
          </div>

          <div className="relative group">
            <div className="aspect-[6/5] rounded-2xl shadow-xl overflow-hidden">
              <img
                src="/projectimage.jpg"
                alt="Project Overview Visual"
                className="w-full h-full object-cover transition-transform duration-700 ease-out
                group-hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectOverview;